import { getRegionLocale } from "./locale";
import type { RegionId } from "./regions";

const gbpFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

/**
 * Format a monetary amount for the selected region (£ / $), whole units.
 */
export function formatMoney(
  amount: number,
  regionId?: RegionId | null,
): string {
  const n = Number.isFinite(amount) ? amount : 0;
  const rounded = Math.round(n);
  return getRegionLocale(regionId).id === "us"
    ? usdFormatter.format(rounded)
    : gbpFormatter.format(rounded);
}

/**
 * Format a monetary amount as whole pounds (e.g. £121,500).
 * Prefer {@link formatMoney} when region is known.
 */
export function formatGbp(amount: number): string {
  return formatMoney(amount, "uk");
}

/**
 * Format a TCI score to one decimal place (e.g. 27.3).
 * Returns "—" when score is null.
 */
export function formatTciScore(score: number | null): string {
  if (score === null || !Number.isFinite(score)) {
    return "";
  }
  return score.toFixed(1);
}
